import Component from "vue-class-component";
import moduleStore from "./store/payMiddlePage";
import Vue from "vue";
import PageState from "./store/state";
import { isWeiXin } from "@/utils/open-download-app";
import { Toast } from 'vant'
import LZString from '../../utils/lz-string.min'
/**components**/
@Component({})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames,
})
export default class payMiddlePagePage
	extends Vue
	implements IvuePage<PageState>
{
	state = new PageState();
	isShow: boolean = false;
	self: Vue = this;
	timer = null;
	time = 60 // 轮询次数
	info:any ={}
	pathTo:any = {
		realVoicePay: 'realVoiceSpeaker',
		realPersonVoiceoverPay: 'realPersonVoiceoverSpeaker',
		vipWechatPay: 'getPayStatusInfo',
		voiceShopPay: 'storeSpeaker'
	}
	created(moduleData: IinjectDatas) {
		this.state = <PageState>moduleData.state;
	}
	beforeDestoryed() {
		console.log('beforeDestoryed -- middle');
		clearTimeout(this.timer)
		this.timer = null
	}
	mounted(moduleData: IinjectDatas) {
        let fromPage = this.$route.query.from;//获取支付页来源-一键配同款值为sameType
        let {phone,desc} = this.$route.query;
        let payType = this.$route.query.payType;
		if(this.timer) {
			clearTimeout(this.timer)
			this.timer = null
		}
        //参数有payType-h5支付 sameType-一键盘剪同款-h5支付
        let isH5PayMethod = fromPage === 'sameType'|| payType;
        if(isH5PayMethod){
            console.log('非微信浏览器,sameType-H5支付')
            this.info = LZString.decompressFromBase64(this.$route.query.info as any);//H5支付
			console.log(this.info,'this.info')
        }else{//公众号支付
            console.log('微信浏览器,非sameType-公众号支付')
            this.info = JSON.parse(this.$route.query.info as any)//公众号支付
        }
        //微信浏览器
		if (isWeiXin()) {//微信浏览器-公众号支付
            this.isShow = true;
            setTimeout(() => {
                this.poll()
            },3500)
		} else {//非微信浏览器
            if(payType==='wxpayH5'){//选择微信支付
				console.log(this.info,'this.info')
              //h5调起微信支付逻辑-微信返回的url
              let formVal = JSON.parse(this.info).mweb_url;
              var form = document.createElement('form');
              document.body.appendChild(form);
              form.method = "post";
              form.action = formVal;
              //该成功页面是一键成片的支付成功页面-若后期有需要可以让产品加其他的支付成功页面
              if(fromPage === 'sameType'){
                let redirect_url = encodeURIComponent(`${location.host}/#/videoPaySuccess`);
                form.action = form.action+"&redirect_url="+redirect_url;
              }
              form.submit();
              document.body.removeChild(form);
            }else if(payType==='alipayH5'){//支付宝支付
              //h5调支付宝支付逻辑-展示阿里返回的页面节点数据
              let formVal = JSON.parse(this.info).alipayInfo;
              let div = document.querySelector('#payDiv');
              if (!div) {
                div = document.createElement('div');
                div.id = 'payDiv';
                document.body.appendChild(div);
              }
              div.innerHTML = formVal;
              const form: any = document.querySelector('#payDiv').children[0];
              form.submit();
            }else{
                //原支付逻辑-保持未动
                 const formVal = `${this.info.alipayInfo}`;
                 console.log('this.info', JSON.stringify(this.info));
                 let div = document.querySelector('#payDiv');
                 // 如果页面已经存在payDiv，则只要修改payDiv的innerHTML就可以了，否则提交的表单永远是第一个表单。
                 if (!div) {
                   div = document.createElement('div');
                   div.id = 'payDiv';
                   document.body.appendChild(div);
                 }
                 div.innerHTML = formVal;
                 const form: any = document.querySelector('#payDiv').children[0];
                 form.submit();
            }
		}
	}
	// 轮询
	poll() {
		this.timer = setTimeout(() => {
			console.log(this.time, 'time');
			
			this.time = this.time - 1
			if(this.time > 0) {
				this.searchOrder()
				this.poll()
			} else {
				clearTimeout(this.timer)
				this.timer = null
			}
		}, 3000)
	}
	searchOrder(isPoll = true) {
		let { orderId, succObj, from, isVoice } = this.info
		// 标识升级省银保
		if(isVoice) {
			from = 'voiceShopPay'
		}
		// this.$http('getPayStatusInfo', {orderId: '110501677484415743'}).then(res => {
		this.$http(this.pathTo[from], {orderId}).then(res => {
			if(res.code === 200 && res.data) {
				this.time = -1
				if(succObj && !isVoice) {
					this.$router.push(succObj as any)
				} else {
					Toast({
						message: "支付成功",
						icon: "none",
						duration: 2000,
					})
				}
			} else {
				if (!isPoll){
					Toast({
						message: "还未付款成功，请继续付款",
						icon: "none",
						duration: 2000,
					})
				}
			}
		})
	}
}
